/**
 * 광고 시간대 정의
 *
 * 새벽 (00:00-07:00): 1시간 단위
 * 이후 (07:00-24:00): 30분 단위
 */

// 시간대 생성 함수
const generateTimeSlots = () => {
  const slots = []
  let id = 1

  // 새벽 시간대 (00:00 ~ 07:00) - 1시간 단위
  for (let hour = 0; hour < 7; hour++) {
    const startHour = String(hour).padStart(2, '0')
    const endHour = String(hour + 1).padStart(2, '0')
    slots.push({
      id: id++,
      label: `${startHour}:00`,
      start: `${startHour}:00`,
      end: `${endHour}:00`,
      period: '새벽',
      icon: '🌙'
    })
  }

  // 이후 시간대 (07:00 ~ 24:00) - 30분 단위
  for (let hour = 7; hour < 24; hour++) {
    const hourStr = String(hour).padStart(2, '0')
    const nextHourStr = String(hour + 1).padStart(2, '0')

    // 시간대 구분
    let period, icon
    if (hour < 9) {
      period = '아침'
      icon = '🌅'
    } else if (hour < 12) {
      period = '오전'
      icon = '☀️'
    } else if (hour < 14) {
      period = '점심'
      icon = '🍽️'
    } else if (hour < 18) {
      period = '오후'
      icon = '🌤️'
    } else if (hour < 21) {
      period = '저녁'
      icon = '🌆'
    } else {
      period = '밤'
      icon = '🌃'
    }

    // 정각 ~ 30분
    slots.push({
      id: id++,
      label: `${hourStr}:00`,
      start: `${hourStr}:00`,
      end: `${hourStr}:30`,
      period,
      icon
    })

    // 30분 ~ 정각
    slots.push({
      id: id++,
      label: `${hourStr}:30`,
      start: `${hourStr}:30`,
      end: hour === 23 ? '24:00' : `${nextHourStr}:00`,
      period,
      icon
    })
  }

  return slots
}

export const TIME_SLOTS = generateTimeSlots()

// 시간대별 그룹화
export const TIME_SLOT_GROUPS = [
  { label: '새벽', period: '새벽', icon: '🌙', description: '00:00 ~ 07:00' },
  { label: '아침', period: '아침', icon: '🌅', description: '07:00 ~ 09:00' },
  { label: '오전', period: '오전', icon: '☀️', description: '09:00 ~ 12:00' },
  { label: '점심', period: '점심', icon: '🍽️', description: '12:00 ~ 14:00' },
  { label: '오후', period: '오후', icon: '🌤️', description: '14:00 ~ 18:00' },
  { label: '저녁', period: '저녁', icon: '🌆', description: '18:00 ~ 21:00' },
  { label: '밤', period: '밤', icon: '🌃', description: '21:00 ~ 24:00' }
]

// 특정 시간대의 슬롯들 가져오기
export const getSlotsByPeriod = (period) => {
  return TIME_SLOTS.filter(slot => slot.period === period)
}

// ID로 슬롯 찾기
export const getSlotById = (id) => {
  return TIME_SLOTS.find(slot => slot.id === id)
}

// 현재 시간에 해당하는 슬롯 찾기
export const getCurrentSlot = () => {
  const now = new Date()
  const koreaTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Seoul' }))
  const currentHour = koreaTime.getHours()
  const currentMinutes = koreaTime.getMinutes()
  const currentTime = `${String(currentHour).padStart(2, '0')}:${String(currentMinutes).padStart(2, '0')}`

  return TIME_SLOTS.find(slot => currentTime >= slot.start && currentTime < slot.end)
}

// 시간 문자열 비교 (HH:MM 형식)
export const isTimeInSlot = (timeStr, slot) => {
  return timeStr >= slot.start && timeStr < slot.end
}

export default {
  TIME_SLOTS,
  TIME_SLOT_GROUPS,
  getSlotsByPeriod,
  getSlotById,
  getCurrentSlot,
  isTimeInSlot
}
